export const ReporteComprobanteRetencionLang = {
    TituloComprobante: {
        es: 'COMPROBANTE DE RETENCIÓN',
        en: 'WITHHOLDING CERTIFICATE',
    },
    TituloProveedor: {
        es: 'DATOS DEL PROVEEDOR',
        en: `VENDOR INFORMATION`
    },
    Rango: {
        es: 'Rango Autorizado:',
        en: 'Authorized Range:'
    },
    FechaEmision: {
        es: 'Fecha:',
        en: 'Date:'
    },
    LimiteEmisión: {
        es: 'Limite de Emisión:',
        en: 'Issuance Limit:'
    },
    conceptoRetencion: {
        es: 'Concepto de Retención',
        en: 'Withholding Concept'
    },
    descripcionImpuesto: {
        es: 'Descripción del impuesto retenido',
        en: 'Description of withheld tax'
    },
    NDocumento: {
        es: 'N° Documento',
        en: 'N° Document'
    },
    Fecha: {
        es: 'Fecha',
        en: 'Date'
    },
    BaseRetencion: {
        es: 'Base de Retención',
        en: 'Withholding Base'
    },
    Tasa: {
        es: 'Tasa',
        en: 'Rate'
    },
    ImporteTotal: {
        es: 'Importe Total Retenido',
        en: 'Total Withheld Amount'
    },
    Original: {
        es: 'Original:Proveedor',
        en: 'Original: Supplier'
    },
    Copia: {
        es: 'Copia: Contabilidad',
        en: 'Copy: Accounting'
    },
    Emitido: {
        es: 'Emitido',
        en: 'Issued'
    },
    Revisado: {
        es: 'Revisado por',
        en: 'Reviewed by'
    },
    Autorizado: {
        es: 'Autorizado',
        en: 'Authorized'
    },
    Persona: {
        es: 'Sres.(a):',
        en:'Sale´s Name:'
    },
    concepto135: {
        es: `Los sujetos pasivos ya sean Personas Jurídicas o Comerciante Individuales, con venta mayores a quince millones de Lempiras anuales (L.15,000,000.00), como Agentes de Retención del uno por ciento (1%), en concepto del Impuesto Sobre la Renta de sus proveedores de bienes y servicios que no estén sujetos al sistema de pagos a cuenta, autorizados por la Administración Tributaria. Base Legal: Acuerdo D`,
        en: `Taxpayers, whether Legal Entities or Individual Traders, with annual sales exceeding fifteen million Lempiras (L.15,000,000.00), act as Withholding Agents of one percent (1%), for Income Tax purposes on their suppliers of goods and services not subject to the advance payment  system, authorized by the Tax Administration. Legal Basis: Agreement D`
    },
    concepto112: {
        es: `Las Personas Jurídicas de Derecho Público y Derecho Privado, que efectúen pagos o constituyan créditos a favor de personas naturales o jurídicas residentes en Honduras, no exoneradas del impuesto sobre la renta, deberán retener y enterar al fisco el doce punto cinco por ciento (12.5%) del monto de los pagos o créditos que efectúen por concepto de honorarios profesionales, dietas, comisiones, gratificaciones, bonificaciones, y remuneración por servicios técnicos. Se exceptúan de esta disposición los pagos efectuados bajo contrato de trabajo celebrados dentro del ejercicio fiscal.`,
        en: `Public and Private Legal Entities, making payments or establishing credits in favor of natural or legal persons residing in Honduras, not exempt from income tax, must withhold and remit to the tax authorities twelve point five percent (12.5%) of the amount of payments or credits made for professional fees, allowances, commissions, bonuses, and remuneration for technical services. Payments made under employment contracts concluded within the fiscal year are exempt from this provision.`
    },
    concepto114: {
        es: `Los ingresos brutos obtenidos de fuente hondureña por personas naturales o jurídicas no residentes o no domiciliadas en el país, deben pagar el impuesto de conformidad a los porcentajes que se detallan a continuación: Sueldos, salarios, comisiones o cualquier otra compensación por servicios prestados ya sea dentro del territorio nacional, excluidas las remesas 25%`,
        en: `Gross income obtained from sources within Honduras by non-resident individuals or entities not domiciled in the country must pay tax according to the following percentages: Salaries, wages, commissions, or any other compensation for services rendered within the national territory, excluding remittances: 25%`
    },
    RTN:{
        es:'RTN:',
        en:'TAX ID:'
    },
    CAI:{
        es:'CAI:',
        en:'CAI:'
    }



}